"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridCardContext = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Paper_1 = tslib_1.__importDefault(require("@mui/material/Paper"));
const GridCardErrorBoundary_1 = tslib_1.__importDefault(require("./GridCardErrorBoundary"));
const GridCardContext = react_1.default.createContext({ initializing: false });
exports.GridCardContext = GridCardContext;
/**
 *
 * @category component
 */
const GridCard = (props, ref) => {
    const { children, initializing = false, onRenderError = undefined, sx, ...PaperProps } = props;
    return (react_1.default.createElement(GridCardContext.Provider, { value: { initializing } },
        react_1.default.createElement(Paper_1.default, { variant: "elevation", ref: ref, ...PaperProps, sx: [
                {
                    display: "flex",
                    flexDirection: "column",
                    overFlow: "hidden",
                    borderRadius: 3,
                },
                ...(Array.isArray(sx) ? sx : [sx]),
            ] },
            react_1.default.createElement(GridCardErrorBoundary_1.default, { onRenderError: onRenderError }, children))));
};
const GridCardWithRef = react_1.default.forwardRef(GridCard);
exports.default = GridCardWithRef;
